import request from '@/utils/request'

// 非权限站点信息获取
export function getSiteInit() {
  return request({
    url: '/setting/siteInit',
    method: 'get',
  })
}
// 获取上传地址
export function getUploadUrl() {
  return request({
    url: '/system/getUploadUrl',
    method: 'get'
  })
}
